import { Col, Row } from 'reactstrap';
import React, { useCallback } from 'react';
import SearchInput from 'components/SearchInput';
import { useApiGet } from 'hooks/useApi';
import Pagination from 'models/Pagination';
import PaginationNav from 'components/Pagination';
import { Link, useNavigate } from 'react-router-dom';
import Icon from 'components/Icon';
import Table from 'components/Table';
import { Column } from 'components/Table/_presenters/props/tableComponentProps';
import { AdminExternalNewsChannel } from 'models/AdminExternalNewsChannel';

const AdminNewsChannelsListPage = () => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = React.useState({
    pageSize: 10,
    page: 1,
    search: ''
  });

  const { data: channelsPage, isLoading } = useApiGet<
    Pagination<AdminExternalNewsChannel>
  >('/admin/news/channels', {
    params: filteredData
  });

  const handleSearch = useCallback(
    (search: string) => {
      setFilteredData({ ...filteredData, search, page: 1 });
    },
    [filteredData]
  );

  const handleClearFilter = useCallback(() => {
    setFilteredData({ pageSize: 10, page: 1, search: '' });
  }, []);

  const handlePageChange = useCallback(
    (page: number) => {
      setFilteredData({ ...filteredData, page });
    },
    [filteredData]
  );

  const goToEdit = useCallback(
    (channel: AdminExternalNewsChannel) => {
      navigate(`/admin/news/channels/${channel.id}`);
    },
    [navigate]
  );

  const columns: Column<AdminExternalNewsChannel>[] = [
    {
      accessor: 'name',
      label: 'Nome',
      render: (name) => <span className="fw-medium">{String(name)}</span>
    },
    {
      accessor: 'rssBaseUrl',
      label: 'RSS Base URL',
      render: (url) => <span>{String(url || '')}</span>
    },
    {
      accessor: 'isActive',
      label: 'Status',
      render: (isActive) => (
        <span className={`badge ${isActive ? 'bg-success' : 'bg-secondary'}`}>
          {isActive ? 'Ativo' : 'Inativo'}
        </span>
      )
    },
    {
      accessor: 'actions',
      label: 'Ações',
      render: () => <Icon icon="eye" className="text-primary" />
    }
  ];

  return (
    <div className="padding-page">
      <Row className="d-flex flex-column flex-md-row">
        <Col className="col-12 col-md">
          <div>
            <p className="text-gray-600">Administração</p>
            <h4 className="fw-bold">Canais de Notícias</h4>
            <span className="small-typography text-gray-600">
              Gerencie os canais de notícias externas da plataforma.
            </span>
          </div>
        </Col>
        <Col className="col-12 col-md align-text mt-3 mt-md-0">
          <Link
            to="/admin/news/channels/create"
            className="btn btn-primary text-white button-register"
          >
            Cadastrar
          </Link>
        </Col>
      </Row>
      <Row className="d-flex align-items-center mt-2 flex-column flex-md-row">
        <Col className="col-12 col-md">
          <SearchInput
            onClearFilter={handleClearFilter}
            onSearchTextChange={handleSearch}
            placeholder="Buscar canal"
          />
        </Col>
      </Row>
      <Table
        data={channelsPage?.items || []}
        columns={columns}
        isLoading={isLoading}
        onRowClick={goToEdit}
      />
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row mt-3">
        {channelsPage && (
          <PaginationNav
            onChange={handlePageChange}
            totalPages={channelsPage.totalPages}
            currentPage={channelsPage.page}
          />
        )}
      </div>
    </div>
  );
};

export default AdminNewsChannelsListPage;
